// Period helpers for Rate Calculator trend tracking.
export const PERIOD_PRESETS = [
  { id: "last12", label: "Last 12 months" },
  { id: "calendar", label: "Last calendar year" },
  { id: "fy", label: "Last financial year (Jul–Jun)" },
  { id: "quarter", label: "Last quarter" },
  { id: "custom", label: "Custom range" },
];

const addMonths = (d, m) => {
  const r = new Date(d);
  r.setMonth(r.getMonth() + m);
  return r;
};
const endOfDay = (d) => {
  const r = new Date(d);
  r.setHours(23, 59, 59, 999);
  return r;
};
const startOfDay = (d) => {
  const r = new Date(d);
  r.setHours(0, 0, 0, 0);
  return r;
};

// Returns { start, end, monthsLength } — monthsLength null for custom (day-based shift).
export const resolvePeriod = (preset, custom, now = new Date()) => {
  const y = now.getFullYear();
  if (preset === "last12") return { start: startOfDay(addMonths(now, -12)), end: now, monthsLength: 12 };
  if (preset === "calendar") return { start: new Date(y - 1, 0, 1), end: endOfDay(new Date(y - 1, 11, 31)), monthsLength: 12 };
  if (preset === "fy") {
    const endYear = now.getMonth() >= 6 ? y : y - 1;
    return { start: new Date(endYear - 1, 6, 1), end: endOfDay(new Date(endYear, 5, 30)), monthsLength: 12 };
  }
  if (preset === "quarter") {
    const qStartMonth = Math.floor(now.getMonth() / 3) * 3 - 3;
    const start = new Date(y, qStartMonth, 1);
    return { start, end: new Date(addMonths(start, 3).getTime() - 1), monthsLength: 3 };
  }
  if (!custom?.from || !custom?.to) return null;
  return { start: startOfDay(new Date(custom.from)), end: endOfDay(new Date(custom.to)), monthsLength: null };
};

export const comparisonPeriod = (period, mode) => {
  if (!period) return null;
  if (mode === "lastYear") {
    return { start: addMonths(period.start, -12), end: addMonths(period.end, -12) };
  }
  if (period.monthsLength) {
    const start = addMonths(period.start, -period.monthsLength);
    return { start, end: new Date(period.start.getTime() - 1) };
  }
  const len = period.end.getTime() - period.start.getTime();
  return { start: new Date(period.start.getTime() - len - 1), end: new Date(period.start.getTime() - 1) };
};

// Most recent snapshot saved on or before the period end (carried forward); null before first save.
export const snapshotAt = (snapshots, end) => {
  let found = null;
  for (const s of snapshots) {
    if (new Date(s.saved_at) <= end) found = s;
    else break;
  }
  return found;
};

export const fmtDate = (d) =>
  new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
